import { useEffect } from 'react';
import './App.css';
import './index.css';

// 导入组件
import { PersonalCapabilities } from './components/PersonalCapabilities';
import { TechnicalKnowledge } from './components/TechnicalKnowledge';
import { ProjectCases } from './components/ProjectCases';
import { Hero } from './components/Hero';
import { GTMMethodology } from './components/GTMMethodology';
import { SiteFooter } from './components/SiteFooter';
import { FullPage } from './components/FullPage';

// 附加样式
import './styles/gtm-collab-foot.css';

// 导入状态管理
import { usePresalesStore } from './stores/usePresalesStore';
import { useFullPageStore } from './stores/useFullPageStore';

function App() {
  const { isLoading, loadExcelData, loadMarkdownFiles } = usePresalesStore();
  const next = useFullPageStore((s) => s.next);

  useEffect(() => {
    const initializeData = async () => {
      try {
        await Promise.all([loadExcelData(), loadMarkdownFiles()]);
        console.log('数据加载完成');
      } catch (error) {
        console.error('数据加载失败:', error);
      }
    };
    initializeData();
  }, [loadExcelData, loadMarkdownFiles]);

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-screen" style={{ background: '#050d1c' }} data-testid="loading-indicator">
        <div className="text-center">
          <div className="relative inline-block">
            <div className="animate-spin rounded-full h-12 w-12 border-2 border-orange-400/30 border-t-orange-500 mx-auto mb-4"></div>
          </div>
          <p style={{ color: 'rgba(230,237,247,0.72)' }} className="animate-pulse">正在加载能力数据…</p>
        </div>
      </div>
    );
  }

  // Hero 的 "查看核心能力" CTA -> 切到第 2 屏(个人能力)
  const handleScrollToContent = () => next();

  return (
    <FullPage>
      {/* 0: Hero */}
      <div className="fp-scroll">
        <Hero onScrollToContent={handleScrollToContent} />
      </div>

      {/* 1: 项目案例 (提到 Hero 之下, 优先展示实战成果) */}
      <div className="fp-scroll">
        <ProjectCases />
      </div>

      {/* 2: 战役沉淀 */}
      <div className="fp-scroll">
        <GTMMethodology />
      </div>

      {/* 3: 能力图谱（顶部 tk header → 雷达 → 3 层图谱） */}
      <div className="fp-scroll">
        <TechnicalKnowledge topSlot={<PersonalCapabilities compact />} />
      </div>

      {/* 4: 认证与荣誉 */}
      <div className="fp-scroll">
        <SiteFooter />
      </div>
    </FullPage>
  );
}

export default App;
